module.exports = __webpack_public_path__ + "no.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/no.svg
// module id = 736
// module chunks = 0